/* eslint-disable better-mutation/no-mutation */
import AbstractModal from 'tradera/legacy/static/utils/abstract-modal';
import breakpoints from 'tradera/legacy/static/utils/breakpoints';

// This Component extends AbstractModal
function ModalTooltipUI() {
    this._triggerOpen = function (evt, opts) {
        this.opts = opts;
        this._open(opts);
    };

    this._adjustModalPosition = function () {
        if (!this._isActive()) {
            return;
        }
        const element = $(this.opts.element);
        const offset = element.offset();
        let thisTop, thisLeft, thisLeftPosition;

        this._addBreakpointClass();

        if (this._fitsToTheRight(element)) {
            thisTop = parseInt(offset.top + element.outerHeight() / 2 - 20, 10);
            thisLeft = parseInt(
                element.offset().left + element.outerWidth() + 15,
                10
            ); // 15 is for the arrow

            this.$modal
                .removeClass(function (index, css) {
                    return (css.match(/\bmodal-tooltip-arrow-\S+/g) || []).join(
                        ' '
                    );
                })
                .addClass('modal-tooltip-arrow-left-top');
        } else {
            thisLeftPosition = this._getLeftPosition(element); // Add 5px to make it differ from the other elements
            thisTop = parseInt(offset.top + element.outerHeight(), 10) + 8; // 8 is for the arrow
            thisLeft = thisLeftPosition.left;

            this.$modal
                .removeClass(function (index, css) {
                    return (css.match(/\bmodal-tooltip-arrow-\S+/g) || []).join(
                        ' '
                    );
                })
                .addClass(
                    'modal-tooltip-arrow-top-' + thisLeftPosition.arrowPosition
                );
        }

        this.$modal.css({ top: thisTop, left: thisLeft });
    };

    this._getLeftPosition = function (element) {
        const windowWidth = parseInt($(window).outerWidth(), 10),
            modalWidth = this.$modal.outerWidth(),
            elementWidth = $(element).outerWidth(),
            bestCenter = parseInt(
                $(element).offset().left + elementWidth / 2,
                10
            ),
            maxLeft = windowWidth - 10 - modalWidth,
            minLeft = 10,
            left = parseInt(bestCenter - modalWidth / 2, 10);

        if (left > maxLeft) {
            return { arrowPosition: 'right', left: maxLeft };
        } else if (left < minLeft) {
            return { arrowPosition: 'left', left: minLeft };
        } else {
            return { arrowPosition: 'center', left: left };
        }
    };

    this._fitsToTheRight = function (element) {
        const windowWidth = parseInt($(window).outerWidth(), 10),
            elementRightOffset = parseInt(
                element.offset().left + element.outerWidth(),
                10
            ),
            roomLeft = windowWidth - (elementRightOffset + 10);

        if (roomLeft > this.$modal.outerWidth()) {
            return true;
        }
        return false;
    };

    this._addBreakpointClass = function () {
        this.$modal.removeClass(function (index, css) {
            return (css.match(/\bmodal-tooltip-size-\S+/g) || []).join(' ');
        });

        this.$modal.addClass('modal-tooltip-size-' + breakpoints.getCurrent());
    };

    this.after('initialize', function () {
        this.on(
            document,
            'ui:save-search:on-modal-tooltip-open',
            this._triggerOpen
        );
        this.on(
            document,
            'utils:window-resize:resized',
            this._adjustModalPosition
        );
    });
}

export default AbstractModal.mixin(ModalTooltipUI);
